/**
 * ─────────────────────────────────────────────────────────────
 *  RANGTARINI — rt-collection.js  v4
 *  Editorial redesign: sidebar toggle, view switcher, price slider
 * ─────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     HEADER HEIGHT → CSS VARIABLES
     Sets --rt-header-h and --rt-toolbar-bottom on :root so
     both the sticky toolbar and sidebar stick correctly below
     whatever the live header height actually is.
  ══════════════════════════════════════════════════════════ */
  function setHeightVars() {
    var header =
      document.querySelector('.rt-hd-wrap') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('header');
    var headerH = header ? header.offsetHeight : 61;
    document.documentElement.style.setProperty('--rt-header-h', headerH + 'px');
  }

  document.addEventListener('DOMContentLoaded', setHeightVars);
  window.addEventListener('load', setHeightVars);
  window.addEventListener('resize', function () {
    setHeightVars();
    /* When resizing to mobile, remove any JS-set column override so CSS media query takes over */
    if (isMobile() && grid) {
      grid.style.removeProperty('--rt-cols');
    }
  }, { passive: true });


  /* ══════════════════════════════════════════════════════════
     SIDEBAR TOGGLE
  ══════════════════════════════════════════════════════════ */
  var sidebar = document.querySelector('.rt-sidebar');
  var toggleBtn = document.querySelector('.rt-sidebar-toggle');
  var mobileOverlay = document.querySelector('.rt-mobile-overlay');
  var sidebarCloseBtn = document.querySelector('.rt-sidebar-close-btn');

  var isMobile = function () { return window.innerWidth <= 768; };

  function isSidebarOpen() {
    if (isMobile()) return sidebar && sidebar.classList.contains('rt-sidebar--mobile-open');
    return sidebar && sidebar.classList.contains('rt-sidebar--open');
  }

  function openSidebar() {
    if (!sidebar) return;
    if (isMobile()) {
      sidebar.classList.add('rt-sidebar--mobile-open');
      if (mobileOverlay) mobileOverlay.classList.add('rt-mobile-overlay--active');
      document.body.style.overflow = 'hidden';
    } else {
      sidebar.classList.add('rt-sidebar--open');
      /* Re-run height calc so sidebar top aligns with refreshed toolbar height */
      setHeightVars();
    }
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-pressed', 'true');
      toggleBtn.querySelector('.rt-toggle-label').textContent = 'Hide filters';
    }
    try { sessionStorage.setItem('rt-sidebar-open', '1'); } catch (e) {}
  }

  function closeSidebar() {
    if (!sidebar) return;
    if (isMobile()) {
      sidebar.classList.remove('rt-sidebar--mobile-open');
      if (mobileOverlay) mobileOverlay.classList.remove('rt-mobile-overlay--active');
      document.body.style.overflow = '';
    } else {
      sidebar.classList.remove('rt-sidebar--open');
    }
    if (toggleBtn) {
      toggleBtn.setAttribute('aria-pressed', 'false');
      toggleBtn.querySelector('.rt-toggle-label').textContent = 'Filter';
    }
    try { sessionStorage.setItem('rt-sidebar-open', '0'); } catch (e) {}
  }

  function toggleSidebar() {
    isSidebarOpen() ? closeSidebar() : openSidebar();
  }

  if (toggleBtn) toggleBtn.addEventListener('click', toggleSidebar);
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeSidebar);
  if (sidebarCloseBtn) sidebarCloseBtn.addEventListener('click', closeSidebar);

  /* Escape key closes sidebar on mobile */
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27) && isMobile() && isSidebarOpen()) {
      closeSidebar();
    }
  });

  /* Restore sidebar state from sessionStorage (desktop only) */
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (!isMobile()) {
        var saved = sessionStorage.getItem('rt-sidebar-open');
        /* Default open on desktop if no saved preference */
        if (saved === null || saved === '1') {
          openSidebar();
        }
      }
    } catch (e) {
      if (!isMobile()) openSidebar();
    }
  });


  /* ══════════════════════════════════════════════════════════
     VIEW SWITCHER (2 / 3 / 4 columns)
  ══════════════════════════════════════════════════════════ */
  var grid = document.querySelector('.rt-grid');
  var viewBtns = document.querySelectorAll('.rt-view-btn');

  function setView(n) {
    if (!grid) return;
    grid.style.setProperty('--rt-cols', n);
    viewBtns.forEach(function (btn) {
      var active = btn.getAttribute('data-view') === String(n);
      btn.classList.toggle('rt-view-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    try { sessionStorage.setItem('rt-view', n); } catch (e) {}
  }

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setView(parseInt(btn.getAttribute('data-view'), 10));
    });
  });

  /* Restore saved view — desktop only; on mobile let CSS media query set columns */
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (!isMobile()) {
        var saved = sessionStorage.getItem('rt-view');
        if (saved) setView(parseInt(saved, 10));
      }
    } catch (e) {}
  });


  /* Checkboxes no longer auto-submit; user clicks Apply at sidebar bottom */


  /* ══════════════════════════════════════════════════════════
     DUAL-RANGE PRICE SLIDER
  ══════════════════════════════════════════════════════════ */
  var COLOR_TRACK  = 'rgba(10,10,10,0.2)';
  var COLOR_ACTIVE = '#0a0a0a';

  function gradient(loPct, hiPct) {
    return 'linear-gradient(to right,'
      + COLOR_TRACK  + ' ' + loPct + '%,'
      + COLOR_ACTIVE + ' ' + loPct + '%,'
      + COLOR_ACTIVE + ' ' + hiPct + '%,'
      + COLOR_TRACK  + ' ' + hiPct + '%)';
  }

  function initSlider(wrap) {
    var minRange   = wrap.querySelector('.rt-range-min');
    var maxRange   = wrap.querySelector('.rt-range-max');
    var track      = wrap.querySelector('.rt-slider-track');
    var outer      = wrap.querySelector('.rt-slider-outer');
    var minDisplay = wrap.querySelector('.rt-price-min-val');
    var maxDisplay = wrap.querySelector('.rt-price-max-val');
    var minHidden  = wrap.querySelector('.rt-price-hidden-min');
    var maxHidden  = wrap.querySelector('.rt-price-hidden-max');

    if (!minRange || !maxRange) return;

    var globalMin = parseFloat(wrap.dataset.min) || 0;
    var globalMax = parseFloat(wrap.dataset.max) || 100000;
    var stepSize  = Math.max(100, Math.round(globalMax / 200));

    minRange.min = maxRange.min = globalMin;
    minRange.max = maxRange.max = globalMax;
    minRange.step = maxRange.step = stepSize;
    minRange.value = parseFloat(wrap.dataset.curMin) || globalMin;
    maxRange.value = parseFloat(wrap.dataset.curMax) || globalMax;

    function refreshFill() {
      var lo = parseFloat(minRange.value);
      var hi = parseFloat(maxRange.value);
      var gap = stepSize;

      if (lo >= hi - gap) {
        if (document.activeElement === minRange) {
          lo = hi - gap;
          minRange.value = lo;
        } else {
          hi = lo + gap;
          maxRange.value = hi;
        }
      }

      var loPct = ((lo - globalMin) / (globalMax - globalMin)) * 100;
      var hiPct = ((hi - globalMin) / (globalMax - globalMin)) * 100;
      var grad  = gradient(loPct, hiPct);

      if (track) track.style.background = grad;
      if (outer) {
        outer.style.backgroundImage    = grad;
        outer.style.backgroundRepeat   = 'no-repeat';
        outer.style.backgroundSize     = 'calc(100% - 16px) 4px';
        outer.style.backgroundPosition = '8px center';
      }

      if (minDisplay) minDisplay.textContent = Math.round(lo).toLocaleString('en-IN');
      if (maxDisplay) maxDisplay.textContent = Math.round(hi).toLocaleString('en-IN');
      if (minHidden)  minHidden.value  = (lo > globalMin) ? Math.round(lo) : '';
      if (maxHidden)  maxHidden.value  = (hi < globalMax) ? Math.round(hi) : '';
    }

    minRange.addEventListener('input', refreshFill);
    maxRange.addEventListener('input', refreshFill);
    refreshFill();
  }

  document.querySelectorAll('.rt-price-slider-wrap').forEach(initSlider);

  /* Price slider changes are applied via the global Apply button at sidebar bottom */


  /* ══════════════════════════════════════════════════════════
     QUICK ADD
     Single-variant: POST /cart/add.js, publish PUB_SUB_EVENTS.cartUpdate.
     Multi-variant: navigate to PDP (let the parent <a> handle it).
  ══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rt-quick-add');
    if (!btn) return;
    /* No-hover / small screens: never quick-add, let the parent <a> open the PDP */
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches || window.innerWidth <= 768) return;

    var isSingle = btn.dataset.singleVariant === 'true';

    if (!isSingle) {
      /* Multi-variant: let the parent <a> navigate naturally — do nothing */
      return;
    }

    /* Single-variant: intercept the anchor and add directly to cart */
    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled) return;

    var variantId = btn.dataset.variantId;
    var originalHTML = btn.innerHTML;

    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        /* Shopify returned an error (e.g. out of stock race) */
        btn.textContent = data.description || 'Unavailable';
        setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 2200);
        return;
      }
      btn.textContent = 'Added ✓';
      /* Fetch updated cart state and publish to Dawn's pub/sub so the header badge updates */
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { cartData: cart, source: 'rt-quick-add' });
          }
        });
      setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 1800);
    })
    .catch(function () {
      btn.textContent = 'Error';
      setTimeout(function () { btn.innerHTML = originalHTML; btn.disabled = false; }, 2200);
    });
  });


})();
